/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  Badge,
  CTA,
  CustomSelect,
  HtmlRaw,
  Icon,
  Modal,
  Tabs,
  Text,
} from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import {
  EVENT_QUIZ_SEND_ANSWERS,
  QUIZ_RESET,
} from '../../../../app/redux/actions/coursedetails';
import {
  Answer,
  AnswerWrapper,
  QuizGlobalWrapper,
  QuizWrapper,
  TabsWrapper,
} from './style';
import { RenderAnswerType } from '../../../components/Quiz';
import QuizResult from '../../../components/Quiz/QuizResult';
import {
  ButtonContainer,
  Question,
  QuizContainer,
} from '../../../components/Quiz/style';

export const ModalQuizEventId = 'ModalQuizEvent';

const defaultTabs = [
  {
    label: 1,
    value: 1,
  },
];

const ModalQuizEvent = ({
  isCompleted,
  mediaIsPhone,
  payload = {},
  quiz,
  title,
  modalClose,
  sendQuizAnsers,
  quizReset,
  modalIsOpen,
}) => {
  const scrollableAreaRef = useRef(null);
  const { elements: data, duration } = payload?.quiz || {};
  const { correct_answers, my_answers, quiz_passed } = quiz || {};
  const [answers, setAnswers] = useState({});
  const [tabs, setTabs] = useState(defaultTabs);
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [showSummary, setShowSummary] = useState(false);
  const [showResults, setShowResults] = useState(false);

  const handleOnClick = ({ qid, type, aid }) => {
    const newAnswers = { ...answers };
    if (type === 'multiple_choice') {
      newAnswers[qid] = answers[qid]?.length > 0 ? [...answers[qid]] : [];
      const aIndex = newAnswers[qid].findIndex((e) => e === aid);
      aIndex < 0
        ? newAnswers[qid].push(aid)
        : newAnswers[qid].splice(aIndex, 1);
    } else {
      newAnswers[qid] = [aid];
    }
    setAnswers(newAnswers);
    checkQuestionCompleted(qid, newAnswers);
  };

  const disableCheckbox = (q, aid) => {
    if (typeof quiz_passed === 'boolean') return true;
    if (q?.question_type === 'multiple_choice') {
      return (
        q?.number_of_required_answers === answers[q?.question_id]?.length &&
        !answers[q?.question_id]?.includes(aid)
      );
    }
    return false;
  };

  const quizIsCompleted = () => {
    let completed = Object.keys(answers)?.length === data?.length;
    (Object.keys(answers) || []).forEach((qid) => {
      const question = data?.find((q) => q?.question_id === Number(qid));
      completed =
        completed &&
        question?.number_of_required_answers === answers[qid]?.length;
    });
    return completed;
  };

  const sendAnswers = () => {
    const body = Object.keys(answers)?.map((qid) => ({
      question_id: Number(qid),
      answer_ids: answers[qid],
    }));
    sendQuizAnsers(payload?.session_id, body);
  };

  const getClasses = (qid, aid) => {
    let classes = '';
    if (!correct_answers || !my_answers) return classes;

    if (my_answers[qid]?.includes(aid)) classes = 'wrong';
    if (correct_answers[qid]?.includes(aid)) classes = 'correct';

    return classes;
  };

  const isChecked = (qid, aid) => {
    if (my_answers && Object.keys(my_answers)?.length > 0) {
      return my_answers[qid]?.includes(aid);
    }
    return answers[qid]?.findIndex((ans_id) => ans_id === aid) >= 0;
  };

  useEffect(() => {
    if (isCompleted) sendAnswers();
    return () => {
      quizReset();
      setAnswers({});
      setTabs(defaultTabs);
      setShowSummary(false);
      setShowResults(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCompleted, modalIsOpen]);

  useEffect(() => {
    if (typeof quiz_passed === 'boolean') {
      setShowResults(true);
    } else setShowResults(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quiz_passed]);

  useEffect(() => {
    if (modalIsOpen) {
      const newtabs = (data || []).map((t, i) => ({
        label: i < 10 ? `0${i + 1}` : i + 1,
        value: i + 1,
      }));
      setTabs(newtabs);
      setActiveTab(newtabs[0]);
    }
  }, [data, modalIsOpen]);

  const checkQuestionCompleted = (qid, newAnswers) => {
    const requiredAnswers = data.find(
      (q) => q?.question_id === qid
    )?.number_of_required_answers;
    const newTabs = [...tabs];
    if (newAnswers[qid]?.length === requiredAnswers) {
      newTabs[activeTab.value - 1].class = 'completed';
    } else newTabs[activeTab.value - 1].class = '';
  };

  const retry = () => {
    quizReset();
    setAnswers({});
    setShowSummary(false);
    setShowResults(false);
    setActiveTab(tabs[0]);
  };

  return (
    <Modal
      title="Quiz di verifica"
      mbTitle={22}
      modalId={ModalQuizEventId}
      scrollableAreaRef={scrollableAreaRef}
    >
      {mediaIsPhone ? (
        <ScrollableArea ref={scrollableAreaRef}>
          <QuizGlobalWrapper>
            <div className="quiz-info">
              <Text type="b2" mb={8}>
                Quiz di verifica del corso:
              </Text>
              <Text type="h2.5" mb={10}>
                {title}
              </Text>
              <div className="duration">
                <Text type="b4">
                  {duration}min <Icon type="clock" />
                </Text>
                <Text type="b4">{data?.length} domande totali</Text>
              </div>
            </div>
            {!showResults && (
              <TabsWrapper>
                <Text type="h3">
                  Domanda {activeTab?.value || tabs?.length}
                </Text>
                <CustomSelect
                  options={tabs.map((t) => ({
                    label: `${t.value}/${tabs?.length}`,
                    value: t.value,
                  }))}
                  placeholder={`1/${tabs?.length}`}
                  onChange={(v) => setActiveTab(v)}
                  selected={{
                    label: `${activeTab?.value || tabs?.length}/${tabs?.length
                      }`,
                    value: activeTab?.value,
                  }}
                  value={`${activeTab?.value || tabs?.length}/${tabs?.length}`}
                />
              </TabsWrapper>
            )}
            {showResults ? (
              <QuizResult quiz={quiz} retry={retry} hideBtns />
            ) : showSummary ? (
              <div>
                <Text type="h3" mb={34}>
                  Riepilogo risposte
                </Text>
                {data?.map((q, i) => {
                  return (
                    <QuizWrapper key={q.question_id} className="resume">
                      <Badge type="news">
                        {q?.number_of_required_answers <= 1
                          ? '1 punto'
                          : `${q?.number_of_required_answers} punti`}
                      </Badge>
                      <Text type="h3">
                        {i + 1}. {q.question}
                      </Text>
                      <AnswerWrapper
                        className="resume"
                        onClick={() => {
                          setShowSummary(false);
                          setActiveTab(tabs[i]);
                        }}
                      >
                        <div>
                          {answers[q.question_id]?.length > 0 ? (
                            answers[q.question_id].map((aid, index) => (
                              <Text
                                type="b3"
                                key={`answer-${index}`}
                                className="answer"
                              >
                                {(q?.answers || []).find(
                                  (ans) => ans?.id === aid
                                )?.value || '-'}
                              </Text>
                            ))
                          ) : (
                            <Text type="b3">-</Text>
                          )}
                        </div>
                        <CTA
                          btnText="modifica"
                          icon="edit-05"
                          type="tertiary"
                        />
                      </AnswerWrapper>
                    </QuizWrapper>
                  );
                })}
              </div>
            ) : (
              <div>
                {data?.map((q, i) => {
                  if (i + 1 !== activeTab?.value) return null;
                  return (
                    <QuizWrapper key={q.question_id}>
                      <Badge type="news">
                        {q?.number_of_required_answers <= 1
                          ? '1 punto'
                          : `${q?.number_of_required_answers} punti`}
                      </Badge>
                      <Text type="h3">
                        {i + 1}. {q.question}
                      </Text>
                      <AnswerWrapper>
                        {q?.answers?.map((a) => (
                          <Answer
                            key={a?.id}
                            className={getClasses(q?.question_id, a?.id)}
                          >
                            <RenderAnswerType
                              label={a?.value}
                              onClick={() =>
                                handleOnClick({
                                  qid: q?.question_id,
                                  aid: a?.id,
                                  type: q?.question_type,
                                })
                              }
                              type={q?.question_type}
                              qid={q?.question_id}
                              disabled={disableCheckbox(q, a?.id)}
                              checked={isChecked(q?.question_id, a?.id)}
                            />
                          </Answer>
                        ))}
                      </AnswerWrapper>
                    </QuizWrapper>
                  );
                })}
              </div>
            )}
          </QuizGlobalWrapper>
        </ScrollableArea>
      ) : (
        <ScrollableArea
          ref={scrollableAreaRef}
          style={{
            minWidth: 'calc(var(--full-width) - 196px)',
            minHeight: 'calc(60vh)',
          }}
        >
          <QuizGlobalWrapper>
            <div className="quiz-info">
              <Text type="b2" mb={8}>
                Quiz di verifica del corso:
              </Text>
              <Text type="h2.5" mb={10}>
                {title}
              </Text>
              <div className="duration">
                <Text type="b4">
                  {duration} min <Icon type="clock" />
                </Text>
                <Text type="b4">{data?.length} domande totali</Text>
              </div>
            </div>
            {!showResults && (
              <TabsWrapper>
                <Tabs
                  tabs={tabs}
                  onChange={(t) => {
                    if (showSummary) setShowSummary(false);
                    setActiveTab(t);
                  }}
                  selected={activeTab}
                  tabType="secondary"
                />
              </TabsWrapper>
            )}
            {showResults ? (
              <QuizResult quiz={quiz} retry={retry} hideBtns />
            ) : showSummary ? (
              <div>
                <Text type="h3" mb={34}>
                  Riepilogo risposte
                </Text>
                {data?.map((q, i) => {
                  return (
                    <QuizWrapper key={q.question_id} className="resume">
                      <Question>
                        <Text type="h3">
                          {i + 1}. {q.question}
                        </Text>
                        <Badge type="news">
                          {q?.number_of_required_answers <= 1
                            ? '1 punto'
                            : `${q?.number_of_required_answers} punti`}
                        </Badge>
                      </Question>
                      <AnswerWrapper
                        className="resume"
                        onClick={() => {
                          setShowSummary(false);
                          setActiveTab(tabs[i]);
                        }}
                      >
                        <div>
                          {answers[q.question_id]?.length > 0 ? (
                            answers[q.question_id].map((aid, index) => (
                              <Text
                                type="b3"
                                key={`answer-${index}`}
                                className="answer"
                              >
                                {(q?.answers || []).find(
                                  (ans) => ans?.id === aid
                                )?.value || '-'}
                              </Text>
                            ))
                          ) : (
                            <Text type="b3">-</Text>
                          )}
                        </div>
                        <CTA
                          btnText="modifica"
                          icon="edit-05"
                          type="tertiary"
                        />
                      </AnswerWrapper>
                    </QuizWrapper>
                  );
                })}
              </div>
            ) : (
              <QuizContainer>
                {data?.map((q, i) => {
                  if (i + 1 !== activeTab?.value) return null;
                  return (
                    <QuizWrapper key={q.question_id}>
                      <Question>
                        <Text type="h3">
                          <HtmlRaw html={`${i + 1}. ${q.question}`} />
                        </Text>
                        <Badge type="news">
                          {q?.number_of_required_answers <= 1
                            ? '1 punto'
                            : `${q?.number_of_required_answers} punti`}
                        </Badge>
                      </Question>
                      <AnswerWrapper>
                        {q?.answers?.map((a) => (
                          <Answer
                            key={a?.id}
                            className={getClasses(q?.question_id, a?.id)}
                          >
                            <RenderAnswerType
                              label={a?.value?.replaceAll('<br />', ' ')}
                              onClick={() =>
                                handleOnClick({
                                  qid: q?.question_id,
                                  aid: a?.id,
                                  type: q?.question_type,
                                })
                              }
                              type={q?.question_type}
                              qid={q?.question_id}
                              disabled={disableCheckbox(q, a?.id)}
                              checked={isChecked(q?.question_id, a?.id)}
                            />
                          </Answer>
                        ))}
                      </AnswerWrapper>
                    </QuizWrapper>
                  );
                })}
              </QuizContainer>
            )}
          </QuizGlobalWrapper>
        </ScrollableArea>
      )}

      <Footer>
        <ButtonContainer>
          {showResults ? (
            <CTA
              fullsize
              btnText="Chiudi"
              onClick={modalClose}
              type="secondary"
            />
          ) : showSummary ? (
            <>
              <CTA
                fullsize
                btnText="modifica"
                type="secondary"
                onClick={() => {
                  setActiveTab(tabs[0]);
                  setShowSummary(false);
                }}
              />
              <CTA
                fullsize
                btnText="conferma"
                onClick={sendAnswers}
                disabled={!quizIsCompleted()}
              />
            </>
          ) : (
            <>
              <CTA
                fullsize
                btnText="indietro"
                type="secondary"
                onClick={() => {
                  setActiveTab(
                    tabs[activeTab?.value ? activeTab.value - 2 : 0]
                  );
                }}
                disabled={activeTab?.value === 1}
              />
              <CTA
                fullsize
                btnText={quizIsCompleted() ? 'vai al riepilogo' : 'avanti'}
                onClick={() => {
                  if (quizIsCompleted() || activeTab?.value === tabs?.length) {
                    setActiveTab();
                    setShowSummary(true);
                  } else setActiveTab(tabs[activeTab?.value]);
                }}
              />
            </>
          )}
        </ButtonContainer>
      </Footer>
    </Modal>
  );
};

ModalQuizEvent.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  isCompleted: PropTypes.bool,
  // state
  quiz: PropTypes.object,
  title: PropTypes.string,
  modalIsOpen: PropTypes.bool,
  payload: PropTypes.object,

  // dispatch
  modalClose: PropTypes.func.isRequired,
  sendQuizAnsers: PropTypes.func.isRequired,
  quizReset: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { quiz, title } = state.coursedetails;
      const { isOpen: modalIsOpen, payload } = state.app.modal;
      return {
        payload,
        quiz,
        title,
        modalIsOpen,
      };
    },
    (dispatch) => ({
      sendQuizAnsers: (session_id, body) =>
        dispatch({
          type: EVENT_QUIZ_SEND_ANSWERS._REQUEST,
          session_id,
          body,
        }),
      quizReset: () => dispatch({ type: QUIZ_RESET }),
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
    })
  ),
  withMediaQueries
)(ModalQuizEvent);
